import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=444bde9c&scoped=true"
import script from "./permission.vue?vue&type=script&lang=ts"
export * from "./permission.vue?vue&type=script&lang=ts"
import style0 from "./permission.vue?vue&type=style&index=0&id=444bde9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444bde9c",
  null
  
)

export default component.exports